import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6042c24"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Material" }
const _hoisted_2 = {
  key: 0,
  class: "employee-summary-section"
}
const _hoisted_3 = { class: "summary-and-export-bar" }
const _hoisted_4 = { class: "summary-info-left" }
const _hoisted_5 = { class: "summary-item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "通话总时长汇总：", -1))
const _hoisted_7 = { class: "summary-value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-divider" }, "|", -1))
const _hoisted_9 = { class: "summary-item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "人均通话总时长：", -1))
const _hoisted_11 = { class: "summary-value highlight" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-divider main-divider" }, "|", -1))
const _hoisted_13 = { class: "summary-item" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "通话量汇总：", -1))
const _hoisted_15 = { class: "summary-value" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-divider" }, "|", -1))
const _hoisted_17 = { class: "summary-item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "summary-label" }, "人均通话量：", -1))
const _hoisted_19 = { class: "summary-value highlight" }
const _hoisted_20 = { class: "export-btns-right" }
const _hoisted_21 = {
  key: 1,
  class: "account-list-section"
}
const _hoisted_22 = { class: "back-bar" }
const _hoisted_23 = { class: "current-employee-info" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }

import { useStore } from '@/store'
import { searchFormConfig } from './config/search.config2'
import { contentTableConfig } from './config/content.config2'
import { modalTableConfig } from './config/modal.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { usePageModalTable } from '@/hooks/usePageModalTable'
import { initEmptyParam } from '@/hooks/useInitParam'
import { Excel, mergeListType } from '@/utils/ExcelJs'
import { getListData } from '@/service/main/system'
import { secondToString } from '@/utils/date-format'
import { reactive, ref, computed } from 'vue'
import { ElMessage } from 'element-plus'
import dayjs from 'dayjs'


export default /*#__PURE__*/_defineComponent({
  __name: 'Statistic2',
  setup(__props) {

const store = useStore()

initEmptyParam()
const userInfo = store.state.login.userInfo
let queryParam = ref()
if (store.state.login.userInfo.isManager != '1') {
  queryParam.value = {
    duration: 0,
    callCount: 0,
    timeSlot: [
      dayjs().subtract(7, 'day').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
      dayjs().subtract(1, 'day').endOf('date').format('YYYY-MM-DD HH:mm:ss')
    ],
    usedBy: userInfo.realName
  }
} else {
  queryParam.value = {
    duration: 0,
    callCount: 0,
    timeSlot: [
      dayjs().subtract(7, 'day').startOf('date').format('YYYY-MM-DD HH:mm:ss'),
      dayjs().subtract(1, 'day').endOf('date').format('YYYY-MM-DD HH:mm:ss')
    ],
  }
}

store.commit('system/changeQueyryInfo', queryParam.value)

const resetCb = () => {
  return queryParam.value
}

const getUsedBy = async () => {
  let userList = await getListData(
    '/main/enterpriseWechat/dingUser/listAll',
    {}
  )
  const userOptions = userList.map((item: any) => {
    return {
      title: item.userName,
      value: item.userName
    }
  })
  const usedByItem = searchFormConfig.formItems.find(
    (item) => item.field === 'usedBy'
  )
  usedByItem!.options = userOptions
}
getUsedBy()

const getGroupList = async () => {
  let groupData = await getListData(
    '/main/enterpriseWechat/dingDept/getGroupList',
    {}
  )
  const groupId = searchFormConfig.formItems.find(
    (item) => item.field === 'groupName'
  )
  groupId!.options = groupData.map((item: any) => {
    return { title: item.deptName, value: item.deptName }
  })
}
getGroupList()

const handleChange = (formData: any) => {
  store.commit('system/changeQueyryInfo', formData)
}

const getCompanyList = async () => {
  let roleData = await getListData('/main/enterpriseWechat/config/listAll', {})

  const roleItem = searchFormConfig.formItems.find(
    (item) => item.field === 'corpId'
  )
  roleItem!.options = roleData.map((item: any) => {
    return { title: item.name, value: item.corPid }
  })
}

getCompanyList()

const getExportData = async () => {
  let queryInfo = store.state.system.queryInfo

  // 确保参数有效性
  const validQueryInfo = {
    ...queryInfo,
    timeSlot: queryInfo.timeSlot || [],
    duration: queryInfo.duration ?? 0,
    callCount: queryInfo.callCount ?? 0
  }

  return await getListData('/main/recordCallDetails/queryExportData', validQueryInfo)
}

const getExportMergeData = async () => {
  let queryInfo = store.state.system.queryInfo

  const validQueryInfo = {
    ...queryInfo,
    timeSlot: queryInfo.timeSlot || [],
    duration: queryInfo.duration ?? 0,
    callCount: queryInfo.callCount ?? 0
  }

  return await getListData('/main/recordCallDetails/queryExportMergeData', validQueryInfo)
}

const getExportEveryDayData = async () => {
  let queryInfo = store.state.system.queryInfo

  const validQueryInfo = {
    ...queryInfo,
    timeSlot: queryInfo.timeSlot || [],
    duration: queryInfo.duration ?? 0,
    callCount: queryInfo.callCount ?? 0
  }

  return await getListData('/main/recordCallDetails/queryExportEveryDayData', validQueryInfo)
}

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

let callDuration = 2 * 60
let totalCallDuration = 30 * 60

const handleVoiceFinance = (item: any) => {
  getExportData().then((res) => {
    let names = []
    let dates = []
    let queryInfo = store.state.system.queryInfo

    // 检查 timeSlot 是否存在且有效
    if (!queryInfo.timeSlot || !Array.isArray(queryInfo.timeSlot) || queryInfo.timeSlot.length < 2) {
      ElMessage({
        type: 'error',
        message: '请先选择通话时间范围后再导出！'
      })
      return
    }

    let startDate = queryInfo.timeSlot[0]?.substring(0, 10)
    let endDate = queryInfo.timeSlot[1]?.substring(0, 10)

    if (!startDate || !endDate) {
      ElMessage({
        type: 'error',
        message: '通话时间格式不正确，请重新选择！'
      })
      return
    }

    if (startDate && endDate) {
      let start = new Date(startDate)
      let end = new Date(endDate)
      while (start <= end) {
        dates.push(ts2str(start.getTime()).substring(0, 10))
        start.setDate(start.getDate() + 1)
      }
    }
    let mergeData = []
    let rawData = res
    for (let i = 0; i < rawData.length; i++) {
      let data = rawData[i]
      // 修复：usedBy 可能为 null，使用 actionName 或其他字段作为标识
      let usedBy = data.usedBy || data.actionName || '未知'
      // 修复：msgTime 是字符串格式 "2026-04-20 10:15:57"，直接提取日期部分
      let date = data.msgDate || (data.msgTime ? data.msgTime.substring(0, 10) : '')
      if (!date) {
        continue
      }
      let row: any = mergeData[usedBy]
      if (!row) {
        row = {
          usedBy: usedBy,
          deptName: data.deptName,
          parentDeptName: data.parentDeptName
        }
        mergeData[usedBy] = row
        names.push(usedBy)
      }
      if (!row[date]) {
        row[date] = {
          total: 0,
          count: 0
        }
      }
      row[date].total += data.duration
      if (data.duration > callDuration) {
        row[date].count += 1
      }
    }
    let exportData = []
    for (let i = 0; i < names.length; i++) {
      let usedBy = names[i]
      let row = mergeData[usedBy]
      for (let j = 0; j < dates.length; j++) {
        let date = dates[j]
        if (!row[date]) {
          continue
        }
        if (row[date].total < totalCallDuration) {
          continue
        }
        if (
          !queryInfo.usedBy &&
          row.deptName &&
          !row.deptName.match(/518.*|投教.*/)
        ) {
          continue
        }

        exportData.push({
          date: date,
          usedBy: row.usedBy,
          parentDeptName: (row.parentDeptName || '-') + '',
          deptName: (row.deptName || '-') + '',
          duration: Math.round(row[date].total / 60),
          count: row[date].count
        })
      }
    }

    const header = [
      'date',
      'usedBy',
      'parentDeptName',
      'deptName',
      'duration',
      'count'
    ]
    const customHeader = [
      '日期',
      '姓名',
      '组',
      '岗位',
      '通话总时长(min)',
      '>2min次数'
    ]
    exportData.sort(function (a, b) {
      function isInvalidValue(str) {
        return str === null || str === undefined || str === '' || str === '-';
      }

      const parentA = a.parentDeptName || '';
      const parentB = b.parentDeptName || '';
      if (parentA !== parentB) {
        return isInvalidValue(parentA) ? 1 : isInvalidValue(parentB) ? -1 : parentA.localeCompare(parentB, 'zh-Hans-CN');
      }

      const deptA = a.deptName || '';
      const deptB = b.deptName || '';
      if (deptA !== deptB) {
        return isInvalidValue(deptA) ? 1 : isInvalidValue(deptB) ? -1 : deptA.localeCompare(deptB, 'zh-Hans-CN');
      }

      if (a.usedBy || b.usedBy) {
        return (isInvalidValue(a.usedBy) ? 1 : isInvalidValue(b.usedBy) ? -1 : a.usedBy.localeCompare(b.usedBy, 'zh-Hans-CN'));
      }

      return 0;
    })
    let filename =
      '财务数据导出-' + ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: filename,
      title: startDate + '至' + endDate + '财务数据',
      data: reactive(exportData),
      header,
      customHeader
    })
  })
}


const handleVoiceExport = (item: any) => {
  getExportData().then((res) => {
    let customHeader = [
      '名称',
      '账户ID',
      '使用人',
      '组',
      '岗位',
      '企业号',
      '客户昵称',
      '客户UnionID',
      '通话总时长(分)',
      '通话总量'
    ]
    let header = [
      'accountName',
      'accountId',
      'usedBy',
      'parentDeptName',
      'deptName',
      'corpName',
      'customName',
      'customUnionid',
      'total',
      'count'
    ]
    let mergeData: any = []
    let mergeKeys = []
    for (let i = 0; i < res.length; i++) {
      let key =
        res[i].corpId +
        ':' +
        res[i].accountId +
        ':' +
        res[i].customId +
        ':' +
        res[i].usedBy
      let group = mergeData[key]
      if (!group) {
        mergeKeys.push(key)
        group = {
          accountName: res[i].accountName,
          accountId: res[i].accountId,
          usedBy: res[i].usedBy,
          parentDeptName: res[i].parentDeptName,
          deptName: res[i].deptName,
          corpName: res[i].corpName,
          customName: res[i].customName,
          customUnionid: res[i].customUnionid,
          total: 0,
          count: 0
        }
        mergeData[key] = group
      }
      group.total += res[i].duration
      group.count += 1
    }
    let exportData = []
    for (let i = 0; i < mergeKeys.length; i++) {
      let key = mergeKeys[i]
      let row = mergeData[key]
      if (row['total'] < 20 * 60 && row['count'] < 10) {
        continue
      }

      row['total'] = Math.round(row['total'] / 60)
      exportData.push(row)
    }
    if (exportData.length === 0) {
      ElMessage({
        type: 'error',
        message: '没有超时的通话记录'
      })
      return
    }
    exportData.sort(function (a, b) {
      function isInvalidValue(str) {
        return str === null || str === undefined || str === '' || str === '-';
      }

      const parentA = a.parentDeptName || '';
      const parentB = b.parentDeptName || '';
      if (parentA !== parentB) {
        return isInvalidValue(parentA) ? 1 : isInvalidValue(parentB) ? -1 : parentA.localeCompare(parentB, 'zh-Hans-CN');
      }

      const deptA = a.deptName || '';
      const deptB = b.deptName || '';
      if (deptA !== deptB) {
        return isInvalidValue(deptA) ? 1 : isInvalidValue(deptB) ? -1 : deptA.localeCompare(deptB, 'zh-Hans-CN');
      }

      if (a.usedBy || b.usedBy) {
        return (isInvalidValue(a.usedBy) ? 1 : isInvalidValue(b.usedBy) ? -1 : a.usedBy.localeCompare(b.usedBy, 'zh-Hans-CN'));
      }

      return 0;
    })
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '超时通话统计-' + filename,
      title: '超时通话统计-' + filename,
      data: reactive(exportData),
      header,
      customHeader
    })
  })
}
const handleEveryDay = (item: any) => {
  let queryInfo = store.state.system.queryInfo
  if (!queryInfo.usedBy) {
    ElMessage({
      type: 'error',
      message: '导出每日数据必须先指定使用人查询后才能导出！'
    })
    return
  }
  getExportEveryDayData().then((res) => {
    let customHeader = [
      '使用人',
      '组',
      '岗位',
      '日期',
      '通话总时长(分)',
      '通话量'
    ]
    let header = [
      'usedBy',
      'parentDeptName',
      'deptName',
      'startDate',
      'total',
      'count'
    ]

    let mergeData: any = []
    let names = []
    for (let i = 0; i < res.length; i++) {
      let key = res[i].usedBy + ':' + res[i].beginDate
      let group = mergeData[key]
      if (!group) {
        group = {
          usedBy: res[i].usedBy,
          deptName: res[i].deptName,
          parentDeptName: res[i].parentDeptName,
          startDate: res[i].beginDate,
          total: 0,
          count: 0
        }
        mergeData[key] = group
        names.push(key)
      }
      group.total += res[i].duration
      group.count += res[i].callCount
    }
    for (let key in mergeData) {
      let row = mergeData[key]
      row['total'] = Math.round(row['total'] / 60)
    }
    let exportData = []
    for (let i = 0; i < names.length; i++) {
      let key = names[i]
      exportData.push(mergeData[key])
    }
    exportData.sort((a, b) => {
      if (!a.startDate || !b.startDate) {
        return !a.startDate ? 1 : -1;
      }
      return new Date(a.startDate) - new Date(b.startDate);
    });
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')

    let mergeList: mergeListType[] = [
      {
        startRow: 1,
        endRow: exportData.length,
        startColumn: 1,
        endColumn: 1
      },
      {
        startRow: 1,
        endRow: exportData.length,
        startColumn: 2,
        endColumn: 2
      },
      {
        startRow: 1,
        endRow: exportData.length,
        startColumn: 3,
        endColumn: 3
      }
    ]

    const excel = new Excel()
    excel.exportExcel({
      name: '通话时长每日汇总-' + filename,
      title: '通话时长每日汇总-' + filename,
      data: reactive(exportData),
      header,
      customHeader,
      mergeList
    })
  })
}
const handleVoiceSum = (item: any) => {
  getExportMergeData().then((res) => {
    let customHeader = [
      '使用人',
      '组',
      '岗位',
      '开始日期',
      '结束日期',
      '通话总时长(分)',
      '通话总时长(时分秒)',
      '通话量'
    ]
    let header = [
      'usedBy',
      'parentDeptName',
      'deptName',
      'startDate',
      'endDate',
      'total',
      'totalFormatted',
      'count'
    ]

    let queryInfo = store.state.system.queryInfo
    let startDate = queryInfo.timeSlot[0].substring(0, 10)
    let endDate = queryInfo.timeSlot[1].substring(0, 10)

    let mergeData: any = []
    let names = []
    for (let i = 0; i < res.length; i++) {
      let key = res[i].usedBy
      let group = mergeData[key]
      if (!group) {
        group = {
          usedBy: res[i].usedBy,
          deptName: res[i].deptName,
          parentDeptName: res[i].parentDeptName,
          startDate: startDate,
          endDate: endDate,
          total: 0,
          totalSeconds: 0,
          count: 0
        }
        mergeData[key] = group
        names.push(key)
      }
      group.total += res[i].duration
      group.totalSeconds += res[i].duration
      group.count += res[i].callCount
    }
    for (let key in mergeData) {
      let row = mergeData[key]
      row['total'] = Math.round(row['total'] / 60)
      row['totalFormatted'] = secondToString(row['totalSeconds'])
    }
    let exportData = []
    for (let i = 0; i < names.length; i++) {
      let key = names[i]
      exportData.push(mergeData[key])
    }
    exportData.sort(function (a, b) {
      function isInvalidValue(str) {
        return str === null || str === undefined || str === '' || str === '-';
      }

      const parentA = a.parentDeptName || '';
      const parentB = b.parentDeptName || '';
      if (parentA !== parentB) {
        return isInvalidValue(parentA) ? 1 : isInvalidValue(parentB) ? -1 : parentA.localeCompare(parentB, 'zh-Hans-CN');
      }

      const deptA = a.deptName || '';
      const deptB = b.deptName || '';
      if (deptA !== deptB) {
        return isInvalidValue(deptA) ? 1 : isInvalidValue(deptB) ? -1 : deptA.localeCompare(deptB, 'zh-Hans-CN');
      }

      if (a.usedBy || b.usedBy) {
        return (isInvalidValue(a.usedBy) ? 1 : isInvalidValue(b.usedBy) ? -1 : a.usedBy.localeCompare(b.usedBy, 'zh-Hans-CN'));
      }

      return 0;
    })
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '通话时长统计汇总-' + filename,
      title: '通话时长统计汇总-' + filename,
      data: reactive(exportData),
      header,
      customHeader
    })
  })
}

const handleVoiceDetail = (item: any) => {
  getExportMergeData().then((res) => {
    let customHeader = [
      '名称',
      '账户ID',
      '使用人',
      '组',
      '岗位',
      '企业名称',
      '开始日期',
      '结束日期',
      '通话总时长(分)',
      '通话量'
    ]
    let header = [
      'accountName',
      'accountId',
      'usedBy',
      'parentDeptName',
      'deptName',
      'corpName',
      'beginDate',
      'endDate',
      'total1',
      'callCount'
    ]
    let exportData = []
    for (let i = 0; i < res.length; i++) {
      let row = res[i]
      row['total1'] = Math.round(row['duration'] / 60) + ''
      exportData.push(row)
    }
    exportData.sort(function (a, b) {
      function isInvalidValue(str) {
        return str === null || str === undefined || str === '' || str === '-';
      }

      const parentA = a.parentDeptName || '';
      const parentB = b.parentDeptName || '';
      if (parentA !== parentB) {
        return isInvalidValue(parentA) ? 1 : isInvalidValue(parentB) ? -1 : parentA.localeCompare(parentB, 'zh-Hans-CN');
      }

      const deptA = a.deptName || '';
      const deptB = b.deptName || '';
      if (deptA !== deptB) {
        return isInvalidValue(deptA) ? 1 : isInvalidValue(deptB) ? -1 : deptA.localeCompare(deptB, 'zh-Hans-CN');
      }

      if (a.usedBy || b.usedBy) {
        return (isInvalidValue(a.usedBy) ? 1 : isInvalidValue(b.usedBy) ? -1 : a.usedBy.localeCompare(b.usedBy, 'zh-Hans-CN'));
      }

      return 0;
    })
    let filename = ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '')
    const excel = new Excel()
    excel.exportExcel({
      name: '通话时长统计-' + filename,
      title: '通话时长统计-' + filename,
      data: reactive(exportData),
      header,
      customHeader
    })
  })
}

const handleSortDataChange = (value: any) => {
  store.commit('system/changeOrderInfo', {
    orderBy: value.prop,
    orderType: value.order
  })
  const queryInfo = store.state.system.queryInfo
  pageContentRef.value?.getPageData(queryInfo)
}

// 三级层级相关变量
const employeeSummaryList = ref<any[]>([])
const currentEmployee = ref<any>(null)
const isLoading = ref(false)

// 计算汇总数据
const totalDurationSummary = computed(() => {
  return employeeSummaryList.value.reduce((sum, emp) => {
    const duration = Number(emp.totalDuration) || 0
    return sum + duration
  }, 0)
})

const totalCallCountSummary = computed(() => {
  return employeeSummaryList.value.reduce((sum, emp) => {
    const count = Number(emp.totalCallCount) || 0
    return sum + count
  }, 0)
})

// 计算人均数据
const avgDurationSummary = computed(() => {
  const count = employeeSummaryList.value.length
  if (count === 0) return 0
  return Math.round(totalDurationSummary.value / count)
})

const avgCallCountSummary = computed(() => {
  const count = employeeSummaryList.value.length
  if (count === 0) return 0
  return Math.round(totalCallCountSummary.value / count)
})

// 第二层：账户列表独立数据（与弹窗数据隔离）
const accountListData = ref<any[]>([])
const accountListCount = ref(0)

// 获取业务员汇总数据
const fetchEmployeeSummary = async (customParams?: any) => {
  isLoading.value = true
  try {
    // 优先使用传入的自定义参数，否则从 store 获取
    const queryInfo = customParams || store.state.system.queryInfo
    const res = await getListData('/main/recordCallDetails/queryByEmpCondition', {
      ...queryInfo,
      pageNo: 1,
      pageSize: 1000
    })

    employeeSummaryList.value = (res.list || []).map((emp: any) => ({
      usedBy: emp.usedBy,
      parentDeptName: emp.parentDeptName,
      deptName: emp.deptName,
      totalDuration: emp.totalDuration || 0,
      totalCallCount: emp.totalCallCount || 0,
      accountList: emp.accountList || []
    }))

    currentEmployee.value = null
  } catch (error) {
    ElMessage.error('获取业务员汇总数据失败')
    console.error(error)
  } finally {
    isLoading.value = false
  }
}

// 处理业务员行点击，展示该业务员下的账户列表
const handleEmployeeClick = (employee: any) => {
  currentEmployee.value = employee
  // 将账户列表设置到独立变量中
  accountListData.value = employee.accountList || []
  accountListCount.value = employee.accountList?.length || 0
}

// 返回业务员列表
const handleBackToEmployeeList = () => {
  currentEmployee.value = null
  accountListData.value = []
  accountListCount.value = 0
}

// 处理查看按钮点击，展示通话明细（第三层）
const handleViewAccountDetail = (account: any) => {
  if (!account.dataList || account.dataList.length === 0) {
    ElMessage({
      type: 'warning',
      message: '该账户暂无通话明细数据'
    })
    return
  }

  // 先关闭可能存在的弹窗，避免重复打开导致循环
  if (pageModalTableRef.value) {
    pageModalTableRef.value.dialogVisible = false
  }

  // 使用 nextTick 确保弹窗关闭后再打开，避免响应式冲突
  setTimeout(() => {
    originalHandleViewClick({
      ...account,
      dataList: [...account.dataList] // 浅拷贝数组，避免响应式引用问题
    })
  }, 50)
}

// 处理搜索按钮点击
const handleSearchClickWrapper = (formData: any) => {
  // 先更新 store 中的查询参数
  store.commit('system/changeQueyryInfo', formData)

  // 直接使用表单数据查询，确保筛选条件完整传递
  fetchEmployeeSummary(formData)
}

// 处理重置按钮点击
const handleResetClickWrapper = () => {
  const resetData = resetCb()
  // 先更新 store 中的查询参数
  store.commit('system/changeQueyryInfo', resetData)

  // 直接使用重置后的数据查询
  fetchEmployeeSummary(resetData)
}

const [
  pageModalTableRef,
  defaultTableInfo,
  dataList,
  originalHandleViewClick,
  dataCount,
  handleSortChange
] = usePageModalTable()

const [pageContentRef, handleResetClick, handleSearchClick] =
  usePageSearch(resetCb)

// 初始化加载业务员汇总数据
fetchEmployeeSummary()

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_PageModalTable = _resolveComponent("PageModalTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_PageSearch, {
      modelValue: _unref(initEmptyParam),
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: handleResetClickWrapper,
      onSearchBtnClick: handleSearchClickWrapper,
      onHandleChange: handleChange
    }, null, 8, ["modelValue", "searchFormConfig"]),
    (currentEmployee.value === null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(secondToString)(totalDurationSummary.value)), 1)
              ]),
              _hoisted_8,
              _createElementVNode("span", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(secondToString)(avgDurationSummary.value)), 1)
              ]),
              _hoisted_12,
              _createElementVNode("span", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("span", _hoisted_15, _toDisplayString(totalCallCountSummary.value), 1)
              ]),
              _hoisted_16,
              _createElementVNode("span", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("span", _hoisted_19, _toDisplayString(avgCallCountSummary.value), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_el_button, {
                type: "primary",
                size: "medium",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleVoiceFinance(employeeSummaryList.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 财务数据导出 ")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "medium",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleVoiceExport(employeeSummaryList.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 导出超时通话 ")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "medium",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (handleVoiceSum(employeeSummaryList.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 下载汇总 ")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "medium",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (handleEveryDay(employeeSummaryList.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 下载每日汇总 ")
                ]),
                _: 1
              }),
              _createVNode(_component_el_button, {
                type: "primary",
                size: "medium",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (handleVoiceDetail(employeeSummaryList.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 下载明细 ")
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_el_skeleton, {
            loading: isLoading.value,
            animated: ""
          }, {
            template: _withCtx(() => [
              _createVNode(_component_el_skeleton_item, {
                variant: "table",
                style: {"width":"100%","height":"400px"}
              })
            ]),
            default: _withCtx(() => [
              (employeeSummaryList.value.length > 0)
                ? (_openBlock(), _createBlock(_component_el_table, {
                    key: 0,
                    data: employeeSummaryList.value,
                    border: "",
                    stripe: "",
                    style: {"width":"100%"},
                    onRowClick: handleEmployeeClick,
                    "highlight-current-row": ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_table_column, {
                        prop: "usedBy",
                        label: "业务员",
                        "min-width": "120"
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "parentDeptName",
                        label: "组",
                        "min-width": "120"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.parentDeptName || '-'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "deptName",
                        label: "岗位",
                        "min-width": "120"
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(scope.row.deptName || '-'), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_table_column, {
                        prop: "totalDuration",
                        label: "通话总时长",
                        "min-width": "140",
                        sortable: "",
                        "sort-method": (a, b) => a.totalDuration - b.totalDuration
                      }, {
                        default: _withCtx((scope) => [
                          _createTextVNode(_toDisplayString(_unref(secondToString)(scope.row.totalDuration)), 1)
                        ]),
                        _: 1
                      }, 8, ["sort-method"]),
                      _createVNode(_component_el_table_column, {
                        prop: "totalCallCount",
                        label: "通话量",
                        "min-width": "100",
                        sortable: "",
                        "sort-method": (a, b) => a.totalCallCount - b.totalCallCount
                      }, null, 8, ["sort-method"]),
                      _createVNode(_component_el_table_column, {
                        label: "操作",
                        "min-width": "120",
                        fixed: "right"
                      }, {
                        default: _withCtx((scope) => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            onClick: _withModifiers(($event: any) => (handleEmployeeClick(scope.row)), ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" 查看账户 ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["data"]))
                : (_openBlock(), _createBlock(_component_el_empty, {
                    key: 1,
                    description: "暂无业务员数据"
                  }))
            ]),
            _: 1
          }, 8, ["loading"])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_el_button, {
              type: "primary",
              link: "",
              icon: "ArrowLeft",
              onClick: handleBackToEmployeeList
            }, {
              default: _withCtx(() => [
                _createTextVNode(" 返回业务员列表 ")
              ]),
              _: 1
            }),
            _createElementVNode("span", _hoisted_23, [
              _createTextVNode(" 当前业务员："),
              _createElementVNode("strong", null, _toDisplayString(currentEmployee.value.usedBy), 1),
              (currentEmployee.value.parentDeptName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_24, " | 组：" + _toDisplayString(currentEmployee.value.parentDeptName), 1))
                : _createCommentVNode("", true),
              (currentEmployee.value.deptName)
                ? (_openBlock(), _createElementBlock("span", _hoisted_25, " | 岗位：" + _toDisplayString(currentEmployee.value.deptName), 1))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_el_table, {
            data: accountListData.value,
            border: "",
            stripe: "",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                prop: "accountName",
                label: "名称",
                "min-width": "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "accountId",
                label: "账户ID",
                "min-width": "120"
              }),
              _createVNode(_component_el_table_column, {
                prop: "usedBy",
                label: "使用人",
                "min-width": "100"
              }),
              _createVNode(_component_el_table_column, {
                prop: "parentDeptName",
                label: "组",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.parentDeptName || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "deptName",
                label: "岗位",
                "min-width": "120"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(scope.row.deptName || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "corpName",
                label: "企业号",
                "min-width": "140"
              }),
              _createVNode(_component_el_table_column, {
                prop: "beginDate",
                label: "开始日期",
                "min-width": "160"
              }),
              _createVNode(_component_el_table_column, {
                prop: "endDate",
                label: "结束日期",
                "min-width": "160"
              }),
              _createVNode(_component_el_table_column, {
                prop: "duration",
                label: "通话总时长",
                "min-width": "120",
                sortable: ""
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(secondToString)(scope.row.duration)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "callCount",
                label: "通话量",
                "min-width": "100",
                sortable: ""
              }),
              _createVNode(_component_el_table_column, {
                label: "通话详情",
                "min-width": "120",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    link: "",
                    onClick: ($event: any) => (handleViewAccountDetail(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" 查看 ")
                    ]),
                    _: 2
                  }, 1032, ["onClick"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          (accountListData.value.length === 0)
            ? (_openBlock(), _createBlock(_component_el_empty, {
                key: 0,
                description: "该业务员暂无账户数据"
              }))
            : _createCommentVNode("", true)
        ])),
    _createVNode(_component_PageModalTable, {
      title: "通话明细",
      ref_key: "pageModalTableRef",
      ref: pageModalTableRef,
      defaultInfo: _unref(defaultTableInfo),
      contentTableConfig: _unref(modalTableConfig),
      dataList: _unref(dataList),
      dataCount: _unref(dataCount),
      onSortChange: _unref(handleSortChange)
    }, {
      customName: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(scope.row.customName + (scope.row.customRemark ? '(' + scope.row.customRemark + ')' : '')), 1)
      ]),
      beginTime: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(scope.row.msgTime), 1)
      ]),
      endTime: _withCtx((scope) => [
        _createElementVNode("span", null, _toDisplayString(scope.row.endTime), 1)
      ]),
      duration: _withCtx((scope) => [
        _createElementVNode("div", null, _toDisplayString(_unref(secondToString)(Number(scope.row.duration))), 1)
      ]),
      _: 1
    }, 8, ["defaultInfo", "contentTableConfig", "dataList", "dataCount", "onSortChange"])
  ]))
}
}

})